"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  language: function language(state) {
    return state.app.language;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  orgGroup: function orgGroup(state) {
    return state.user.orgGroup;
  },
  orgName: function orgName(state) {
    return state.user.orgName;
  },
  permissionRoutes: function permissionRoutes(state) {
    return state.permission.routes;
  },
  addRouters: function addRouters(state) {
    return state.permission.addRoutes;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  orgGroupName: function orgGroupName(state) {
    return state.user.orgGroupName;
  },
  orgGroupId: function orgGroupId(state) {
    return state.user.orgGroupId;
  }
};
var tmplAttrGetters = {
  industryAttrList: function industryAttrList(state) {
    return state.industryAttrList;
  },
  checkedAttrIdList: function checkedAttrIdList(state) {
    return state.checkedAttrIdLst;
  },
  settingAttrId: function settingAttrId(state) {
    return state.settingAttrId;
  },
  settingAttrScope: function settingAttrScope(state) {
    return state.checkedAttrConfig.scope;
  },
  settingAttrChannelCodes: function settingAttrChannelCodes(state) {
    return state.checkedAttrConfig.channelCodeList;
  },
  settingAttrNameAlias: function settingAttrNameAlias(state) {
    return state.checkedAttrConfig.attrNameAlias;
  },
  settingAttrRequire: function settingAttrRequire(state) {
    return state.checkedAttrConfig.require;
  },
  settingAttrSelect: function settingAttrSelect(state) {
    return state.checkedAttrConfig.select;
  },
  settingAttrType: function settingAttrType(state) {
    return state.checkedAttrConfig.type;
  },
  settingAttrCascade: function settingAttrCascade(state) {
    return state.checkedAttrConfig.cascade;
  },
  settingAttrCheckedValIds: function settingAttrCheckedValIds(state) {
    return state.checkedAttrConfig.checkedAttrValIds;
  },
  settingAttrCheckedValues: function settingAttrCheckedValues(state) {
    return state.checkedAttrConfig.checkedValues;
  },
  settingAttrValues: function settingAttrValues(state) {
    return state.checkedAttrConfig.values;
  }
};
var _default = exports.default = getters;